import React, { useEffect, useState } from 'react';

import Stepper from '../../component/Stepper/Stepper';
import AppHeader from '../../component/AppHeader/app-header';
import PricingSection from './components/PricingSection';
import { useStepper } from '../../hooks/useStepper';
import PageLoader from '../../component/PageLoader';
import { toast } from 'react-toastify';
import { fetchSubscriptionPlans } from '../../services/subscription';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionQuery } from '../../hooks/useSubscriptionQuery';
import { useDispatch } from 'react-redux';
import { setBillingType, setPlan } from '../../store/reducers/subscriptionSlice/subscriptionSlice';

const SubscriptionPlan = () => {
	const { steps, currentStep, goToStep } = useStepper();
	const [plans, setPlans] = useState([]);
	const [loading, setLoading] = useState(false);
	const { billing, updateQuery, plan: selectedPlanKey } = useSubscriptionQuery();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const getPlans = async () => {
		try {
			setLoading(true);

			const response = await fetchSubscriptionPlans();

			setPlans(response.plans);

			if (selectedPlanKey) {
				const selectedPlan = response.plans.find((item) => item.key === selectedPlanKey);

				if (selectedPlan) {
					dispatch(
						setPlan({
							id: selectedPlan?._id,
							key: selectedPlan?.key,
							title: selectedPlan?.name,
							description: selectedPlan?.meta?.description,
							billing: selectedPlan?.billing || [],
						}),
					);
				}
			}

			dispatch(setBillingType(billing || 'monthly'));
		} catch (error) {
			console.error(error);
			toast.error('Failed to fetch subscription plans');
			setPlans([]);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getPlans();
	}, []);

	useEffect(() => {
		const completed = localStorage.getItem('subscriptionCompleted') === 'true';

		if (!completed && window.location.pathname !== '/subscription-plan') {
			navigate(`/subscription-plan${window.location.search}`, {
				replace: true,
			});
		}
	}, [navigate]);

	return (
		<>
			<AppHeader title="Subscription Plan" />
			<main className="main-wrapper">
				<div className="subscription-layout">
					<Stepper
						steps={steps}
						currentStep={currentStep}
						onStepClick={goToStep}
					/>

					{loading ? (
						<PageLoader />
					) : (
						<PricingSection
							billing={billing}
							setBilling={(value) =>
								updateQuery({
									billing: value,
									step: 'select-plan',
								})
							}
							plans={plans}
						/>
					)}
				</div>
			</main>
		</>
	);
};

export default SubscriptionPlan;
